import script from "./AudienceFooterSteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudienceFooterSteps.vue?vue&type=script&setup=true&lang=ts"

import "./AudienceFooterSteps.vue?vue&type=style&index=0&id=c70dff9e&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c70dff9e"]])

export default __exports__